<template>
  <div class="page">
    <mobileHeader :title="stateList[stateIndex].title" rightType="scanCode"></mobileHeader>
    <div class="center">
      <GasCylinderInfo v-if="!isMultiple" :bottleInfo="bottleInfoCache" />
      <bottleList v-else />
      <div class="state-title">
        <img :src="stateList[stateIndex].img" alt="" />
        <div>{{ stateList[stateIndex].title }}</div>
      </div>
      <template v-if="stateList[stateIndex].selectList">
        <div v-for="(item, index) in stateList[stateIndex].selectList" :key="index" class="select-item" @click="selectVal = index" :class="selectVal == index && 'select-item-act'">
          <img v-if="selectVal == index" src="@/assets/images/select-act.png" alt="">
          <img v-else src="@/assets/images/select-no.png" alt="">
          {{item.label}}
        </div>
      </template>
      <van-form class="form-list" @submit="submit">
        <template v-if="stateList[stateIndex].input || stateList[stateIndex].selectList[selectVal].input">
          <template v-for="(it, i) in (stateList[stateIndex].input ? stateList[stateIndex].input : stateList[stateIndex].selectList[selectVal].input)">
            <div class="input-item" :key="i">
              <template v-if="it.type == 'address'">
                <van-field
                  v-model="post.address"
                  :disabled="true"
                  :placeholder="it.placeholder"
                />
                <img src="@/assets/images/dingwei_1.png" alt="" />
              </template>
              <template v-if="it.type == 'number'">
                <van-field
                  v-model="it.value"
                  type="number"
                  @input="numberInput"
                  :placeholder="it.placeholder"
                />
                <img src="@/assets/images/xiugai.png" alt="" />
              </template>
              <template v-if="it.type == 'text'">
                <van-field
                  v-model="it.value"
                  :disabled="true"
                  :placeholder="it.placeholder"
                />
                <img src="@/assets/images/xiugai.png" alt="" />
              </template>
              <template v-if="it.type == 'select'">
                <van-field
                  v-model="staffListObj[it.value]"
                  :disabled="true"
                  @click="selectStaff = true, selectIndex = i"
                  :placeholder="it.placeholder"
                />
                <img src="@/assets/images/xiugai.png" alt="" />
              </template>
              <template v-if="it.type == 'carCode'">
                <van-field
                  v-model="car_number"
                  :disabled="true"
                  @click="selectCodeShow = true"
                  :placeholder="it.placeholder"
                />
                <img src="@/assets/images/saoma.png" @click="openScan()" alt="" />
              </template>

            </div>
          </template>
        </template>
        
        <div class="submit">
          <van-button block type="primary" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>

    </div>
    <div class="mask" v-if="codeLoading">
      <div>
        <van-loading type="spinner" color="#1989fa" />
        <div class="text">图片识别中...</div>
      </div>
    </div>
    <van-popup v-model="selectCodeShow" :style="{ width: '86%' }">
      <van-field
        v-model="car_number"
        center
        clearable
        placeholder="请选择或者输入车牌号码"
      >
        <template #button>
          <van-button size="small" type="primary" @click="selectCarCode(car_number)">确定</van-button>
        </template>
      </van-field>
      <div class="car-code-box">
        <div class="car-code-item" v-for="(it,i) in carCodeList" :key="i" @click="selectCarCode(it)">
          {{it}}<van-icon name="cross" @click.stop="spliceCarCode(it)" />
        </div>

      </div>
    </van-popup>
    <van-popup v-model="selectStaff" position="bottom">
      <van-picker
        title="标题"
        show-toolbar
        value-key="name"
        :columns="staffList"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import mobileHeader from "@/components/mobileHeader";
import GasCylinderInfo from "@/components/GasCylinderInfo";
import {carLicense} from "@/api/flowPath"
import { Toast, Dialog } from "vant";
import { bottleFillingAdd, bottleDeliveryAdd, bottleGasAdd, bottleUseAdd, bottleRecyclingAdd, bottleDetectionAdd, bottleScrapAdd, bottleOtherAdd, getStaffList } from "@/api/flowPath";
import bottleList from "@/components/bottleList";
export default {
  components: {mobileHeader, GasCylinderInfo, bottleList},
  data(){
    return{
      staffList: [],
      selectStaff: false,
      selectIndex: null,
      isMultiple: false,
      selectCodeShow: false,
      carCodeList: [],
      codeLoading: false,
      imgUrl: "",
      testImg: "6666",
      post: {address:""},
      state: null,
      stateIndex: null,
      selectVal: 0,
      title: "气瓶流转",
      car_number: "",
      stateList: [
        {
          title: "充装",
          img: require("@/assets/images/ranqichupei.png"),
          state: 1,
          selectList: [
            {
              label: "空瓶进站",
              text: "空瓶进站",
              value: 1,
              showInput: true,
              input: [
                {
                  value: "",
                  type: "number",
                  placeholder: "请输入充装前余气实测重量"
                },
                {
                  value: "",
                  type: "carCode",
                  placeholder: "请扫码或输入车牌号"
                }
              ]
            },
            {
              label: "重瓶发出",
              text: "重瓶发出",
              value: 2,
              input: [
                {
                  value: "",
                  type: "carCode",
                  placeholder: "请扫码或输入车牌号"
                }
              ]
            },
            {
              label: "重瓶退回",
              text: "重瓶退回",
              value: 3,
              input: [
                {
                  value: "",
                  type: "carCode",
                  placeholder: "请扫码或输入车牌号"
                }
              ]
            },
            {
              label: "重瓶入库",
              text: "重瓶入库",
              value: 4,
              input: [
                {
                  value: "",
                  type: "number",
                  placeholder: "请输入充装后实测重量"
                },
                {
                  value: "",
                  type: "carCode",
                  placeholder: "请扫码或输入车牌号"
                }
              ]
            }
          ]
        },
        {
          title: "门店",
          state: 2,
          img: require("@/assets/images/ranqiqiye.png"),
          selectList: [
            {
              label: "重瓶接收（气站发出）",
              text: "重瓶接收",
              value: 1,
              input: [
                {
                  value: "",
                  type: "carCode",
                  placeholder: "请扫码或输入车牌号"
                }
              ]
            },
            {
              label: "空瓶退回（退给气站）",
              text: "空瓶退回",
              value: 2,
              input: [
                {
                  value: "",
                  type: "carCode",
                  placeholder: "请扫码或输入车牌号"
                }
              ]
            },
            {
              label: "重瓶退回（退给气站）",
              text: "重瓶退回",
              value: 3,
              input: [
                {
                  value: "",
                  type: "carCode",
                  placeholder: "请扫码或输入车牌号"
                }
              ]
            }
          ]
        },
        {
          title: "送气",
          text: "送气",
          img: require("@/assets/images/cheliangjianguan.png"),
          state: 3,
          input: [
            {
              value: "",
              type: "address",
              placeholder: "自动获取位置"
            },
            {
              value: "",
              type: "select",
              placeholder: "请选择配送员"
            },
            {
              value: "",
              type: "carCode",
              placeholder: "请扫码或输入车牌号"
            }
          ]
        },
        {
          title: "回收",
          img: require("@/assets/images/huishouzhan.png"),
          state: 5,
          selectList: [
            {
              label: "空瓶回收",
              text: "空瓶回收",
              value: 1,
              input: [
                {
                  value: "",
                  type: "select",
                  placeholder: "请选择配送员"
                },
                {
                  value: "",
                  type: "number",
                  placeholder: "请输入当前轻瓶内余气实测重量"
                },
                {
                  value: "",
                  type: "carCode",
                  placeholder: "请扫码或输入车牌号"
                }
              ]
            },
            {
              label: "重瓶回收（领瓶退回）",
              text: "重瓶回收",
              value: 2,
              input: [
                {
                  value: "",
                  type: "select",
                  placeholder: "请选择配送员"
                },
                {
                  value: "",
                  type: "carCode",
                  placeholder: "请扫码或输入车牌号"
                }
              ]
            }
          ]
        }
      ],
    }
  },
  computed: {
    bottleInfo() {
      return this.$store.state.bottleInfo;
    },
    bottleInfoCache(){
      return this.$store.state.bottleInfoCache;
    },
    bottleId(){
      return this.$store.state.bottleId
    },
    address(){
      return this.$store.state.location.address
    },
    userRole() {
      return this.$store.state.userRole;
    },
    staffListObj(){
      const obj = {}
      this.staffList.map(it => {
        obj[it.id] = it.name
      })
      return obj
    }
  },
  created(){
    this.isMultiple = !!this.$route.query.isMultiple
    this.carCodeList = this.mixGetCache("carCodeList", [])
    // if(this.carCodeList.length){
    //   this.car_number = this.carCodeList[0]
    // }
    this.state = this.$route.query.state
    this.stateIndex = this.stateList.findIndex(it => it.state == this.state)
    this.getStaffList()
    this.getInfo(this.state)
    this.getLocation();
    window.takePhotoResult = (result) => {
      // Toast({message: "扫码成功"})
      // console.log(result, "我是base64图片")
      this.getBase64Text("data:image/jpeg;base64," + result.data)
    }
    if(this.address) {(this.post.address = this.address);return true}
    const time = setInterval(_=>{
      this.address && (this.post.address = this.address, clearInterval(time))
    }, 2000)
  },
  unmounted(){
    if(this.$store.state.time != null){
      clearInterval(this.$store.state.time)
      this.$store.state.time = null
    }
  },
  methods: {
    async getStaffList(){
      if([2, 3].indexOf(this.stateIndex) == -1)return false
      const {code, msg, data} = await getStaffList()
      if(code != 200) return Toast({message: msg})
      this.staffList = data
    },
    getCarCode(pic){
      console.log("成功发起请求")
      this.codeLoading = true
      carLicense({pic}).then(res => {
        this.codeLoading = false
        console.log(res,"ress")
        // console.log(res.data,"ress")
        if(res.data && res.data.number){
          this.car_number = res.data.number
          this.setCarCodeCache(res.data.number)
          return false
        }
        Toast({message: ret.msg || '扫码错误，请重试'})
        // console.log(res.data.data.number)
      }).catch(err => {
        console.log(err,"err")
        this.codeLoading = false
        Toast({message:"请尝试重新拍照或者手动输入"})
      })
    },
    // 把码添加进缓存
    async setCarCodeCache(number){
      console.log("开始执行了")
      let carCodeList = this.carCodeList
      const findIndex = carCodeList.findIndex(it => it == number)
      if(findIndex != -1){
        carCodeList.splice(findIndex, 1)
      }
      carCodeList.unshift(number)
      this.carCodeList = carCodeList
      this.mixSetCache("carCodeList", carCodeList)
    },
    // 删除一条
    spliceCarCode(number){
      let carCodeList = this.carCodeList
      const findIndex = carCodeList.findIndex(it => it == number)
      carCodeList.splice(findIndex, 1)
      this.carCodeList = carCodeList
      this.mixSetCache("carCodeList", carCodeList)
    },
    async getInfo(state) {
      switch(state){
        // case "1":
        //   this.post.value1 = this.bottleInfoCache.user_name;
        //   break;
        // case "2":
        //   this.post.value1 = this.bottleInfoCache.shop_name;
        //   break;
        // case "3":
        //   this.stateList[2].input[1].value = this.bottleInfoCache.user_name;
        //   break;
        // case "4":
        //   this.post.value1 = this.bottleInfoCache.using_name;
        //   break;
        // case "5":
        //   this.post.value1 = this.bottleInfoCache.user_name;
        //   break;
      }
    },
    selectCarCode(number){
      if(number == "")return Toast("车牌不能为空")
      this.car_number = number
      this.setCarCodeCache(number)
      this.selectCodeShow = false
    },
    getLocation() {
      this.mixGetLocation((location) => {
        this.post.address = location.address;
      });
    },
    openScan(){
      JS.takePhote()
      console.log("打开相机")
    },
    numberInput(e){
      // this.stateList[this.state].selectList[this.selectVal].input[0].data.indexOf('-') == 0 && (this.stateList[this.state].selectList[this.selectVal].input[0].data = '')
    },
    submit(){

      Dialog.confirm({
        title: "提示",
        message: "是否确认提交",
        beforeClose: this.beforeCloses,
      });
    },
    async beforeCloses(action, done){
      if (action === "confirm") {
        // const bottle_id = this.bottleId
        const bottle_id = this.isMultiple ? this.$store.state.bottleIdList : this.bottleId
        const stateItem = this.stateList[this.stateIndex]
        // return console.log(stateItem,"stateItem")
        const car_number = this.car_number
        // console.log(bottle_id,"bottle_id")
        // console.log(this.state, this.userRole ,"bottle_id")
        // 充装  bottleFillingAdd √√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√
        if (this.state == 1 && (this.userRole == 1 || this.userRole == 3)) {
          const ret = await bottleFillingAdd({
            bottle_id,
            station_check_location: this.post.address,
            station_check_weight: this.selectVal == 0 ? stateItem.selectList[0].input[0].value : "",
            step_name: stateItem.selectList[this.selectVal].text,
            car_number
          });
          done(true);
          return this.afterCallback(ret,"充装")
        }
        // 配送 bottleDeliveryAdd √√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√
        if(this.state == 2 && (this.userRole == 1 || this.userRole == 2)){
          const ret = await bottleDeliveryAdd({
            bottle_id,
            delivery_location: this.post.address,
            step_name: stateItem.selectList[this.selectVal].text,
            car_number
          });
          done(true);
          return this.afterCallback(ret,"配送")
        }
        // 送气 bottleGasAdd √√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√√
        if(this.state == 3 && (this.userRole == 1 || this.userRole == 2)){
          if(!stateItem.input[1].value){
            Toast({message: `请选择配送员`,duration: 500})
            return done(true);
          }
          const ret = await bottleGasAdd({
            bottle_id,
            gas_location: this.post.address,
            step_name: stateItem.text,
            staff_id: stateItem.input[1].value,
            car_number
          });
          done(true);
          return this.afterCallback(ret,"送气")
        }
        // 使用 bottleUseAdd XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
        if(this.state == 4 && (this.userRole == 1 || this.userRole == 2)){
          const ret = await bottleUseAdd({
            bottle_id,
            use_location: this.post.address,
            step_name: stateItem.selectList[this.selectVal].text,
            car_number
            // use_shop: this.post.value2
          });
          done(true);
          return this.afterCallback(ret,"使用")
        }
        // 回收 bottleRecyclingAdd
        if(this.state == 5 && (this.userRole == 1 || this.userRole == 2)){
          if(!stateItem.selectList[this.selectVal].input[0].value){
            Toast({message: `请选择配送员`,duration: 500})
            return done(true);
          }
          const ret = await bottleRecyclingAdd({
            bottle_id,
            recycling_location: this.post.address,
            recycling_weight: this.selectVal == 0 ? stateItem.selectList[0].input[1].value : "",
            step_name: stateItem.selectList[this.selectVal].text,
            // staff_id: stateItem.input[1].value,
            staff_id: stateItem.selectList[this.selectVal].input[0].value,
            car_number
          });
          done(true);
          return this.afterCallback(ret,"回收")
        }
        // 检测 bottleDetectionAdd XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
        if(this.state == 6 && (this.userRole == 1 || this.userRole == 2)){
          const ret = await bottleDetectionAdd({
            bottle_id,
            detection_location: this.post.address,
            detection_unit: this.post.value2
          });
          done(true);
          return this.afterCallback(ret,"检测")
        }
        // 报废 bottleScrapAdd XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
        if(this.state == 7 && (this.userRole == 1 || this.userRole == 2)){
          const ret = await bottleScrapAdd({
            bottle_id,
            scrap_location: this.post.address,
            scrap_unit: this.post.value2
          });
          done(true);
          return this.afterCallback(ret,"报废")
        }
        // 其他 bottleOtherAdd XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
        if(this.state == 8 && (this.userRole == 1 || this.userRole == 2)){
          const ret = await bottleOtherAdd({
            bottle_id,
            other_location: this.post.address,
            other_text: this.post.value2
          });
          done(true);
          return this.afterCallback(ret,"其他")
        }
      } else {
        done(true);
      }
    },
    afterCallback({ code, msg }, text){
      code == 200
        ? (Toast({message: `完成${text}流程`,duration: 500}),
          setTimeout(_ => {
            this.mixGetBottleInfo();
            this.userRole == 3 ? this.$router.push("/flowPath/scanCode") : this.$router.push("/flowPath/index")
          }, 500))
        : Toast({message: msg ? msg:'服务端错误', duration: 500});
      code == 200 && this.setCarCodeCache(this.car_number)
    },
    // 压缩图片 获取base64数据
    getBase64Text(url){
      let image = new Image();
      image.src = url
      //image.onload为异步加载
      image.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = 400;
        canvas.height = (image.height * 400) / image.width;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, 400, (image.height * 400) / image.width);
        
        var quality = 0.8;
        //这里的dataurl就是base64类型
        var dataURL = canvas.toDataURL("image/jpeg", quality);//使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
        // this.imgUrl = dataURL
        this.getCarCode(dataURL)
      }
    },
    onConfirm(e){
      console.log(this.stateIndex,"this.stateIndex")
      console.log(this.selectVal,"this.stateIndex")
      console.log(this.selectIndex,"this.selectIndex")
      console.log(this.state,"this.state")
      this.selectStaff = false
      // this.stateList[this.stateIndex].input[this.selectIndex].value = e.id
      if(this.stateList[this.stateIndex].input){
        this.stateList[this.stateIndex].input[this.selectIndex].value = e.id
      }else{
        this.stateList[this.stateIndex].selectList[this.selectVal].input[this.selectIndex].value = e.id

      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .header-title{
  font-size: 5vw;
}
.state-title {
  text-align: center;
  padding-top: 7.6vw;
  padding-bottom: 5.5vw;
  font-size: 6.7vw;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #34D132;
  width: 100%;
  img {
    width: 19.4vw;
  }
}
.page {
  display: flex;
  background: #f7f7f7;
  height: auto;
  min-height: 100vh;
  width: 100vw;
  flex-direction: column;
  .center {
    flex-grow: 1;
    .select-item{
      background: #BFBFBF;
      width: 84vw;
      margin: 4px 8vw;
      line-height: 14vw;
      border-radius: 1.4vw;
      text-align: center;
      position: relative;
      color: white;
      img{
        width: 7.4vw;
        height: 7.4vw;
        position: absolute;
        top: 3.3vw;
        left: 4.7vw;
      }
    }
    .select-item:active{
      opacity: 0.8;
    }
    .select-item-act{
      background: #4DD65B;

    }
  }
}
.form-list {
  flex: 1;
  background: #f7f7f7;
  padding: 0 8vw;
  .input-item {
    box-sizing: border-box;
    width: 84vw;
    height: 14vw;
    background: #ffffff;
    border: 1px solid #bfbfbf;
    border-radius: 1.4vw;
    margin-bottom: 1vw;
    display: flex;
    align-items: center;
    input {
      outline: none;
      border: 0;
      flex: 1;
      padding: 0 4vw;
      background: white;
      font-size: 4.2vw;
    }
    img {
      width: 7.5vw;
      margin-right: 2.3vw;
    }
  }
  .submit {
    margin: 6vw 0;
    img {
      width: 84vw;
      height: 100%;
    }
    ::v-deep .van-button {
      width: 83vw;
      height: 14vw;
      border: 0;
      background: #43a3fe;
      font-size: 7vw;
      border-radius: 4px;
    }
  }
}
.mask{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(80, 79, 79, 0.534);
  display: flex;
  justify-content: center;
  align-items: center;
  & > div{
    width: fit-content;
    height: fit-content;
    text-align: center;
    font-size: 20px;
    line-height: 20px;
  }
  & > div > .text{
    margin-top: 10px;
  }
  ::v-deep .van-loading{
    margin: auto;
  }
}
.car-code-box{
  display: flex;
  flex-wrap: wrap;
}
.car-code-item{
  padding: 4px 0;
  width: 29%;
  text-align: center;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: calc(10% / 6);
  & ::v-deep .van-icon-cross{
    &::after{
      content: "";
      position: absolute;
      top: -10px;
      left: -10px;
      width: calc(100% + 20px);
      height: calc(100% + 20px);
    }
  }
}
.car-code-item:active{
  opacity: 0.5;
}

::v-deep .van-popup{
  border-radius: 4px;
  overflow: hidden;
}
::v-deep .van-field__control:disabled{
  -webkit-text-fill-color: #323233;
  color: #323233;
}
</style>